<template>
  <div class="side_box">
    <div>
      <label for="name">name</label>
      <span v-if="this.item">{{this.item.name}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="ref">Amount of steps</label>
      <span v-if="this.item">{{this.item.stepCount}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="description">List of Subparts</label>
      <div class="container flex-col steps">
        <VerticalStepBullets class="steps-bullets" :totalSteps="this.item.customStep.length" :currentStep="this.item.customStep.length" />
        <div class="steps-list" v-if="!isEditing">
          <label
            v-for="(step, index) in this.item.customStep" 
            :key="index" 
            for="ref">
              {{step.name}}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VerticalStepBullets from "@/components/base/VerticalStepBullets.vue";

export default {
  components: {
    VerticalStepBullets,
  },
  computed: {
  },
  props: {
    item: Object
  },
};
</script>

<style lang="scss" scoped>  
@import "@/style/base.scss";
@import "@/style/components/sideBox.scss";

.side_box {
  max-height: 440px;
}

.steps {
  padding-top: 16px;
  max-height: 240px;
  overflow-y: auto;

  .steps-list {
    label {
      width: 100%;
      padding: 8px 6px;
      font-family: Montserrat;
      font-weight: 500;
      font-size: 14px;
      text-align: left;
      color: #707070;
      margin-bottom: 0;

      &+label{
        margin-top: 28px;
      }
    }
  }
}
</style>
